import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Elowen Marchetti',
  role: 'Head of Outreach',
  company: 'BrightSpark Academy',
  quote: 'Goblincamp transformed our school outreach strategy. Their curriculum-aligned content resonates with both educators and parents. Enrollment inquiries increased by 45% in just three months!',
  rating: 5
}, {
  name: 'Theron Voskuijlen',
  role: 'Co-founder',
  company: 'LearnLeap',
  quote: "As an EdTech startup, we struggled to reach decision-makers in schools. Goblincamp's targeted campaigns connected us with over 200 schools in our first quarter. Their expertise is unmatched.",
  rating: 5
}, {
  name: 'Isolde Ferreira-Katz',
  role: 'Director of Curriculum',
  company: 'Mosaic Schools',
  quote: "The quality and educational rigor of Goblincamp's content is exceptional. They understand pedagogy and marketing equally well—a rare combination that delivers real results.",
  rating: 5
}];
export function Testimonials() {
  return <section className="py-20 px-4 bg-white" data-id="element-208">
      <div className="max-w-7xl mx-auto" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-210">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-211">
            Loved by Educators & EdTech Leaders
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-212">
            See what our partners have to say about working with Goblincamp
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-213">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} whileHover={{
          scale: 1.03
        }} className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl p-8 shadow-lg border-4 border-purple-200" data-id="element-214">
              {/* Star Rating */}
              <div className="flex gap-1 mb-4" data-id="element-215">
                {[...Array(testimonial.rating)].map((_, i) => <motion.div key={i} initial={{
              opacity: 0,
              scale: 0
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.3,
              delay: index * 0.1 + i * 0.1
            }} data-id="element-216">
                    <Star size={24} className="text-yellow-400" fill="#FBBF24" data-id="element-217" />
                  </motion.div>)}
              </div>

              {/* Quote */}
              <p className="text-gray-700 text-lg mb-6 italic" data-id="element-218">
                "{testimonial.quote}"
              </p>

              {/* Author */}
              <div className="border-t-2 border-purple-200 pt-4" data-id="element-219">
                <p className="font-bold text-gray-900 text-lg" data-id="element-220">
                  {testimonial.name}
                </p>
                <p className="text-purple-600 font-medium" data-id="element-221">
                  {testimonial.role}
                </p>
                <p className="text-gray-600" data-id="element-222">{testimonial.company}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}